import { dealStore } from '@/models/stores';
import { useParams } from '@tanstack/react-router';
import { validate as isValidUuid } from 'uuid';

const useDealShortId = () => {
  const { shortId: shortIdParam } = useParams({ strict: false });
  let shortId = shortIdParam;

  // UX NOTE: this supports the case where user puts in the deal id
  // instead of the short id
  if (shortIdParam && isValidUuid(shortIdParam)) {
    shortId = dealStore.getById(shortIdParam)?.short_id ?? shortIdParam;
  }

  return { shortId: shortId as string };
};

export default useDealShortId;
